export var PanelPadding;
(function (PanelPadding) {
    PanelPadding["None"] = "none";
    PanelPadding["Sm"] = "sm";
    PanelPadding["Lg"] = "lg";
})(PanelPadding || (PanelPadding = {}));
export var PanelCssClass;
(function (PanelCssClass) {
    PanelCssClass["Base"] = "iress-panel";
    PanelCssClass["none"] = "iress-panel--padding-none";
    PanelCssClass["Stretch"] = "iress-panel--stretch";
    PanelCssClass["sm"] = "iress-panel--padding-sm";
    PanelCssClass["lg"] = "iress-panel--padding-lg";
    PanelCssClass["Inversed"] = "iress-panel--inversed";
})(PanelCssClass || (PanelCssClass = {}));
//# sourceMappingURL=panel.types.js.map